<template>
    <b-dropdown
        @hide="onHideDropdown"
        @show="onShowDropdown"
        toggle-tag="div"
        variant="white"
        class="dropdown-container"
        toggle-class="w-100"
        no-caret
    >
        <template slot="button-content">
            <AttributesDropdownItem :is-open="isDropdownOpen" caret>
                <template slot="title">
                    {{ value.name }}
                </template>
            </AttributesDropdownItem>
        </template>
        <b-dropdown-item-button
            v-for="attribute in attributes"
            :key="attribute.id"
            class="dropdown-list-item border-bottom"
            @click="$emit('input', attribute)"
        >
            <AttributesDropdownItem>
                <template slot="title">
                    {{ attribute.name }}
                </template>
                <template slot="description">
                    {{ attribute.description }}
                </template>
            </AttributesDropdownItem>
        </b-dropdown-item-button>
    </b-dropdown>
</template>

<script>
import AttributesDropdownItem from './AttributesDropdownItem'

export default {
    name: 'AttributesDropdown',
    components: {
        AttributesDropdownItem,
    },
    data() {
        return {
            isDropdownOpen: false,
        }
    },
    props: {
        value: {
            type: Object,
            required: false,
        },
        attributes: {
            type: Array,
            required: false,
        },
    },
    methods: {
        onHideDropdown() {
            this.isDropdownOpen = false
        },
        onShowDropdown() {
            this.isDropdownOpen = true
        },
    },
}
</script>

<style lang="scss" scoped>
.dropdown-container {
    border-radius: 5px;
    border: 2px solid #e4e5e6;
    width: 100%;
}
</style>

<style lang="scss">
div.btn.dropdown-toggle {
    padding: 0;
    cursor: pointer;
}
.dropdown-container {
    .dropdown-menu {
        width: 100%;
    }
    .dropdown-list-item .dropdown-item {
        padding: 0 !important;
        &:active,
        &:focus {
            outline: 0;
            background-color: #f0f3f5;
            box-shadow: 0 0 0 3px rgba(0, 155, 219, 0.25);
        }
    }
    .dropdown-list-item:last-child {
        border: 0 !important;
    }
}
</style>
